import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface IProps {
    text: string;
}

const LogIn = ({ text }: IProps) => {
    const { t: localizer } = useTranslation();

    return (
        <div className="mt-5 text-center">
            <p>
                {localizer(text)}?{" "}
                <Link
                    to="/login"
                    className="font-weight-medium text-primary"
                >
                    {" "}
                    Login
                </Link>{" "}
            </p>
        </div>
    );
};

export default LogIn;
